import { Check } from "lucide-react"

import { cn } from "@/lib/utils"

interface Step {
  label: string
}

interface StepIndicatorProps {
  steps: Step[]
  currentStep: number
  ariaLabel: string
}

export function StepIndicator({ steps, currentStep, ariaLabel }: StepIndicatorProps) {
  return (
    <ol className="flex w-full items-center gap-2" aria-label={ariaLabel}>
      {steps.map((step, index) => {
        const stepNumber = index + 1
        const isCompleted = stepNumber < currentStep
        const isCurrent = stepNumber === currentStep
        const isLast = stepNumber === steps.length

        return (
          <li
            key={step.label}
            className={cn("flex flex-1 items-center gap-2", isLast && "flex-none")}
            aria-current={isCurrent ? "step" : undefined}
          >
            <div className="flex items-center gap-2">
              <span
                className={cn(
                  "flex size-7 shrink-0 items-center justify-center rounded-full border text-xs font-medium transition-colors",
                  isCompleted &&
                    "border-primary bg-primary text-primary-foreground",
                  isCurrent &&
                    "border-primary bg-primary text-primary-foreground",
                  !isCompleted && !isCurrent &&
                    "border-border bg-muted text-muted-foreground",
                )}
              >
                {isCompleted ? <Check className="size-3.5" /> : stepNumber}
              </span>
              <span
                className={cn(
                  "text-xs font-medium whitespace-nowrap",
                  (isCurrent || isCompleted) ? "text-foreground" : "text-muted-foreground",
                )}
              >
                {step.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={cn(
                  "h-px flex-1 transition-colors",
                  isCompleted ? "bg-primary" : "bg-border",
                )}
              />
            )}
          </li>
        )
      })}
    </ol>
  )
}
